module.exports = require('./helpers/bundle-url').getBundleURL('hkxlb') + "she-hulk.2acf9bfa.png";